module.exports = __webpack_public_path__ + "img/message3.6754d92f.png";